import { DEFAULT_SERVER_URL } from '../../react/features/base/settings/constants';

/**
 * Common methods used to determine availability of features or layout
 */
export default class Env {

    /**
     *
     * @returns {string}
     */
    static getBaseUrl() {
        return navigator.product === 'ReactNative' ? DEFAULT_SERVER_URL : config.baseUrl;
    }

    /**
     *
     * @returns {string}
     */
    static checkIfConfigPHPExist() {
        return typeof config !== 'undefined' ? config.baseUrl : '';
    }

    /**
     *
     * @returns {boolean}
     */
    static isMobile() {
        return Boolean(navigator.userAgent.match(/Android|iPad|iPhone|iPod/i));
    }

    /**
     *
     * @returns {boolean}
     */
    static isIOS() {
        return Boolean(navigator.userAgent.match(/iPad|iPhone|iPod/i));
    }

    /**
     *
     * @returns {boolean}
     */
    static _isWizyconf = null;

    static isWizyconf() {
        if (this._isWizyconf === null) {
            this._isWizyconf = /Wizyconf|Ubiconf/i.test(navigator.userAgent);
        }

        return this._isWizyconf;
    }

    /**
     *
     * @returns {boolean}
     */
    static isVision() {
        return Boolean(navigator.userAgent.match(/rk3288/i));
    }

    /**
     * Map of ratios for detection of dual/triple
     *
     * Monitors 16/9 16/10  min  max
     * One      1.7  1.6     -   2.5
     * Two      3.5  3.2    2.5  4.4
     * Three    5.3  4.8    4.4   -
     */
    /**
     *
     * @returns {boolean}
     */
    static isDualMonitor() {
        return window.innerWidth > 3800
            && window.innerWidth / window.innerHeight >= 2.5
            && window.innerWidth / window.innerHeight < 4.4;
    }

    /**
     *
     * @returns {boolean}
     */
    static isTripleMonitor() {
        return window.innerWidth > 3800
            && window.innerWidth / window.innerHeight >= 4.4;
    }

    /**
     *
     * @returns {boolean}
     */
    static isCollageMonitor() {
        return false; // Blocked while not tested
    }

    /**
     *
     * @returns {boolean}
     */
    static isCombinedMonitor() {
        return Env.isDualMonitor() || Env.isTripleMonitor() || Env.isCollageMonitor();
    }

    /**
     *
     * @returns {boolean}
     */
    static isSupportWiServise() {
        return !Env.isMobile() && !/Linux/.test(window.navigator.platform);
    }

    /**
     *
     * @returns {boolean}
     */
    static isFirefox() {
        return /Firefox/.test(window.navigator.userAgent);
    }

    /**
     *
     * @returns {boolean}
     */
    static isSafari() {
        return /Safari/.test(window.navigator.userAgent) && !/Chrome/.test(window.navigator.userAgent);
    }

    /**
     *
     * @returns {boolean}
     */
    static isScreenSharingOnlyMode() {
        return (location.search.split('screen=')[1] || '').substr(0, 2) === 'on';
    }

    /**
     *
     * @returns {boolean}
     */
    static isMacintosh() {
        return navigator.platform.indexOf('Mac') !== -1;
    }

    /**
     *
     * @returns {boolean}
     */
    static isWildixAppLessThan217Version() {
        const oldVersion = '2.1.6';
        const userAgentLowerCase = navigator.userAgent.toLowerCase();
        // eslint-disable-next-line no-useless-escape
        const match = userAgentLowerCase.match(/WildixCollaboration\/([0-9\.]*)/i);

        return Boolean(match && match[1] <= oldVersion);
    }

    /**
     *
     * @returns {boolean}
     */
    static isLocalHost() {
        return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    }

    /**
     * Waiting when element appears in the DOM
     * @param parent
     * @param selector
     * @return {Promise<unknown> | Promise.Promise}
     */
    static elementReady(parent, selector) {
        return new Promise(resolve => {
            const el = parent.querySelector(selector);

            if (el) {
                resolve(el);
            }
            new MutationObserver((mutationRecords, observer) => {
                // Query for elements matching the specified selector
                Array.from(parent.querySelectorAll(selector)).forEach(element => {
                    resolve(element);

                    // Once we have resolved we don`t need the observer anymore.
                    observer.disconnect();
                });
            }).observe(parent.documentElement, {
                childList: true,
                subtree: true
            });
        });
    }
}
